import { ActionReducerMapBuilder, Draft } from '@reduxjs/toolkit'

import { TDownloadActions } from './createDownloadActions'
import { createInitialAsyncDownloadState, IAsyncDownloadState } from './types'

interface IWithDownloadState {
  download: IAsyncDownloadState
}

export const addDownloadCaseReducers = <S extends IWithDownloadState>(
  builder: ActionReducerMapBuilder<S>,
  actions: TDownloadActions
) => {
  builder
    .addCase(actions.requestingStarted, (state: Draft<S>) => {
      state.download.status = 'requesting'
      state.download.loadedBytes = 0
      state.download.totalBytes = null
      state.download.remainingBytes = null
      state.download.percent = null
      state.download.startedAt = Date.now()
      state.download.finishedAt = null
      state.download.error = null
    })

    .addCase(actions.downloadStarted, (state: Draft<S>, action) => {
      state.download.status = 'starting'
      state.download.loadedBytes = 0
      state.download.totalBytes = action.payload.totalBytes
      state.download.remainingBytes = action.payload.totalBytes
      state.download.percent = action.payload.totalBytes ? 0 : null
      state.download.startedAt = Date.now()
      state.download.finishedAt = null
      state.download.error = null
    })

    .addCase(actions.downloadProgress, (state: Draft<S>, action) => {
      state.download.status = 'downloading'
      state.download.loadedBytes = action.payload.loadedBytes

      if (state.download.totalBytes !== null) {
        state.download.remainingBytes = state.download.totalBytes - action.payload.loadedBytes
        state.download.percent = Math.round(
          (action.payload.loadedBytes / state.download.totalBytes) * 100
        )
      } else {
        state.download.remainingBytes = null
        state.download.percent = null
      }
    })

    .addCase(actions.downloadSucceeded, (state: Draft<S>) => {
      state.download.status = 'success'
      state.download.percent = 100
      state.download.remainingBytes = 0
      state.download.finishedAt = Date.now()
    })

    .addCase(actions.downloadFailed, (state: Draft<S>, action) => {
      state.download.status = 'error'
      state.download.error = action.payload.error
      state.download.finishedAt = Date.now()
    })

    .addCase(actions.processingStarted, (state: Draft<S>) => {
      state.download.status = 'processing'
    })

    .addCase(actions.downloadCancelled, (state: Draft<S>) => {
      state.download.status = 'cancelled'
      state.download.finishedAt = Date.now()
    })

    .addCase(actions.resetDownload, (state: Draft<S>) => {
      state.download = createInitialAsyncDownloadState()
    })
}
